import { Directive, QueryList, ViewContainerRef, AfterViewInit } from '@angular/core';
import { GasFormKeyDirective } from '../../../utils/gas-form-key/gas-form-key.directive';

const INDEX = {
  container: '_lContainer',
  wrapper: 0,
  component: 8,
};

@Directive({
  selector: '[gasCustomFilter]',
})
export class GasCustomTableFilterDirective implements AfterViewInit {
  public component: any;

  public get filters(): QueryList<GasFormKeyDirective> {
    return this.component?.filterControls;
  }

  constructor(
    private host: ViewContainerRef,
  ) {}

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.component = this.getComponent(this.host);
    });
  }

  public getComponent(ref: any): any {
    // eslint-disable-next-line
    const index = ref._hostTNode?.directiveStart;
    // eslint-disable-next-line
    const component = ref._hostLView[index];

    return component || ref[INDEX.container][INDEX.wrapper][INDEX.component];
  }
}
